import styled, { createGlobalStyle } from 'styled-components/macro'

import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const Theme = createGlobalStyle`
:root {
  --theme-color: ${theme.colors.accent.komi()} !important;
  --links-color: ${theme.colors.accent.komi(0.55)} !important;
  --music-link-color: ${theme.colors.accent.komi(0.8)} !important;
}
`

export const WideImage = styled.figure`
  margin: 8rem 0;
  position: relative;
  z-index: 1;

  img {
    display: block;
    width: 100%;
    max-height: 100vh;
    object-fit: cover;
    object-position: center bottom;
  }

  ${mq.large} {
    &::before,
    &::after {
      content: '';
      position: absolute;
      bottom: 100%;
      left: 0;
      display: block;
      width: 20%;
      height: 8rem;
      mask: linear-gradient(to top, black, transparent);
      pointer-events: none;
      background: var(--background);
    }

    &::after {
      bottom: auto;
      top: 100%;
      mask: linear-gradient(to bottom, black, transparent);
    }
  }
`
